module.exports = __webpack_public_path__ + "img/2_AR.fcde2afb.png";